import { defineSlotRecipe } from '@chakra-ui/react';
import { selectAnatomy } from '@chakra-ui/react/anatomy';

export default defineSlotRecipe({
  slots: selectAnatomy.keys(),
  variants: {
    size: {
      md: {
        control: {
          textStyle: 'md',
        },
      },
      lg: {
        control: {
          '--input-height': 'sizes.12',
        },
      },
    },
  },
});
